<template>
    <div class="modal" id="role-details-modal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div id="role-details-form">
                    <div class="modal-header">
                        <h4 class="m-0">Gestionar rol: <strong>{{ roleName }}</strong></h4>
                        <button @click="closeModal" class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div v-if="isLoading" style="padding: 5ch 0;">
                        <SpeenComponent 
                            :isAutomatic="true" 
                            :ringWidth="14" 
                            :spinnerSize="15" 
                            :isverticalAligned="true" 
                        />
                    </div>
                    <div v-else>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <h5>Usuarios asociados</h5>
                                    <div class="user-column">
                                        <div class="form-check form-switch" v-for="user in users" :key="user.id">
                                            <input name="users[]" :value="user.id" class="form-check-input" type="checkbox"
                                                :id="`user-${user.id}`" :checked="selectedUsers.includes(user.name)"
                                                @change="handleRoleUsersChange(user.name, $event.target.checked)">
                                            <label class="form-check-label" :for="`user-${user.id}`">
                                                {{ user.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h5>Paquetes de permisos del rol</h5>
                                    <div class="packages-column">
                                        <div class="form-check form-switch role-permission-package-switch" v-for="permissionPackage in totalPermissionPackages" :key="permissionPackage.id">
                                            <div class="d-flex justify-content-between align-items-center custom-full-width">
                                                <div>
                                                    <input name="permissionPackages[]" :value="permissionPackage.id" class="form-check-input" type="checkbox"
                                                        :id="`perm-${permissionPackage.id}`"
                                                        :checked="roleSelectedPermissionPackages.includes(permissionPackage.name)"
                                                        @change="handleRolePermissionPackagesChange(permissionPackage.name, $event.target.checked)"
                                                        :disabled="isForbiddenRole">
                                                    <label class="form-check-label" :for="`perm-${permissionPackage.id}`">
                                                        {{ permissionPackage.name }}
                                                    </label>
                                                </div>
                                                <div>
                                                    <button type="button" class="btn btn-info-custom btn-sm" @click="viewPermissionPackage(permissionPackage.id)">
                                                        <span class="mdi mdi-information-outline"></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-danger" type="button" @click="closeModal">Cerrar</button>
                            <button class="btn btn-success" type="button" @click="saveChanges">Guardar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PermissionPackageViewModal
            v-if="showPermissionPackageModal"
            :viewPermissionPackageName="viewPermissionPackageName"
            :viewPermissionPackageDescription="viewPermissionPackageDescription"
            @close-modal="closePermissionPackageViewModal"
        />
    </div>
</template>

<script>
import axios from 'axios';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import PermissionPackageViewModal from './PermissionPackageViewModal.vue';

export default {
    name: 'PermissionManageModal',
    components: {
        SpeenComponent,
        PermissionPackageViewModal,
    },
    props: {
        roleId: {
            type: Number,
            required: true
        },
        roleName: {
            type: String,
            required: true
        },
        usersData: {
            type: Array,
            required: true
        },
        totalPermissionPackages: {
            type: Array,
            required: true
        },
        isForbiddenRole: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            selectedUsers: [],
            roleSelectedPermissionPackages: [],
            showPermissionPackageModal: false,
            viewPermissionPackageName: '',
            viewPermissionPackageDescription: '',
            isLoading: true,
        }
    },
    methods: {
        getUsersByRole() {
            axios.get(`/api/roles/${this.roleId}/get-users-and-permission-packages`)
                .then(response => {
                    this.selectedUsers = response.data.users.map(user => user.name);
                    this.roleSelectedPermissionPackages = response.data.permissionPackages.map(permissionPackage => permissionPackage.name);
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        handleRoleUsersChange(userName, isChecked) {
            if (isChecked) {
                if (!this.selectedUsers.includes(userName)) {
                    this.selectedUsers.push(userName);
                }
            } else {
                const index = this.selectedUsers.indexOf(userName);
                if (index !== -1) {
                    this.selectedUsers.splice(index, 1);
                }
            }
        },
        handleRolePermissionPackagesChange(permissionPackageName, isChecked) {
            if (isChecked) {
                if (!this.roleSelectedPermissionPackages.includes(permissionPackageName)) {
                    this.roleSelectedPermissionPackages.push(permissionPackageName);
                }
            } else {
                const index = this.roleSelectedPermissionPackages.indexOf(permissionPackageName);
                if (index !== -1) {
                    this.roleSelectedPermissionPackages.splice(index, 1);
                }
            }
        },
        saveChanges() {
            axios.put(`/api/roles/${this.roleId}/update-users-and-permission-packages`, {
                users: this.selectedUsers,
                permissionPackages: this.roleSelectedPermissionPackages
            })
                .then(response => {
                    showCustomSuccessSweetAlert('Cambios guardados correctamente');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        closeModal() {
            this.$emit('close-modal');
        },
        viewPermissionPackage(permissionPackageId) {
            let permissionPackage = this.totalPermissionPackages.find(permissionPackage => permissionPackage.id === permissionPackageId);
            this.viewPermissionPackageName = permissionPackage.name;
            this.viewPermissionPackageDescription = permissionPackage.descrip;
            this.showPermissionPackageModal = true; 
        },
        closePermissionPackageViewModal() {
            this.showPermissionPackageModal = false;
        },
    },
    computed: {
        users() {
            return this.usersData.filter(u => u.name.toLowerCase() !== 'superadmin' && u.name.toLowerCase() !== 'erp')
        },
    },
    mounted() {
        this.getUsersByRole();
    },
}
</script>